import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core'
import { RouterLink } from '@angular/router'
import { RedirectRequest } from '@azure/msal-browser'
import { AuthService } from '@appShared/services'
import { b2cAuthorities, B2CAuthority_ } from '@appShared/b2c-policies'
import { SITE_DIRECTORY_ROUTES } from '@appShared/site-directory.routes'

@Component({
    selector: 'app-unauthorized',
    template: `
    <div class="text-center mt-3 mb-5">
      <h2>401: Unauthorized</h2>
      <p class="mx-auto text-center mt-3">
        You must be logged in to access this page.<br/>
        Click the appropriate link below to login.
      </p>
      <div class="buttons mt-4 mx-auto d-flex flex-column gap-2">
         <button (click)="login(b2cAuthority.defaultSignUpSignIn)" class="btn btn-large btn-primary">
            Sign In
         </button>
         <a [routerLink]="['/']" class="btn btn-large btn-primary">GO TO HOMEPAGE</a>
      </div>

    </div>
  `,
    styles: [`
      h2 {
        font-size: 40px;
        font-weight: 700;
        color: blue;
      }
      p { max-width: 400px; }
      .buttons{ max-width:230px }
      a.contact, a.contact:hover, a.contact:focus, a.contact:visited {
        color: #029edb;
        text-decoration: none;
      }
  `],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink]
})

export class UnauthorizedComponent {
   private _authService = inject(AuthService)
   private _redirectUrl = computed(() => {
      return this._authService.redirectUrl() || `/${SITE_DIRECTORY_ROUTES.content.uri}`
   })
   b2cAuthority = B2CAuthority_

   login(authorityType: B2CAuthority_) {
      const redirectUrl = this._redirectUrl()

      const b2cAuthority = b2cAuthorities.get(authorityType)

      this._authService.login({ authority: b2cAuthority.authority, state: redirectUrl } as RedirectRequest)
   }
}
